import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useToast } from './AdminToast';
import { Link } from 'react-router-dom';

const AdminAlerts = () => {
    const [alerts, setAlerts] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const toast = useToast();
    const token = localStorage.getItem("adminToken");

    useEffect(() => {
        fetchAlerts();
        const interval = setInterval(fetchAlerts, 30000); // Poll every 30s
        return () => clearInterval(interval);
    }, []);

    // Close dropdown on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchAlerts = async () => {
        try {
            const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:5000' : '';
            const res = await axios.get(`${baseUrl}/api/admin/alerts`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            // If new alerts found, show a toast for the latest one
            if (res.data.length > alerts.length && alerts.length > 0) {
                const latest = res.data[0];
                toast.info(latest.message);
                setUnreadCount(prev => prev + (res.data.length - alerts.length));
            } else if (alerts.length === 0) {
                setUnreadCount(res.data.length);
            }

            setAlerts(res.data);
        } catch (err) {
            console.error("Alerts fetch failed");
        }
    };

    const handleBellClick = () => {
        setShowDropdown(!showDropdown);
        setUnreadCount(0);
    };

    return (
        <div style={{ position: "relative" }} ref={dropdownRef}>
            {/* Bell Icon */}
            <button
                onClick={handleBellClick}
                style={{
                    background: "rgba(255,255,255,0.05)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    borderRadius: "12px",
                    width: "40px",
                    height: "40px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    cursor: "pointer",
                    position: "relative",
                    transition: "all 0.2s"
                }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.05)"}
            >
                🔔
                {unreadCount > 0 && (
                    <span style={{
                        position: "absolute",
                        top: "-4px",
                        right: "-4px",
                        background: "#ef4444",
                        color: "white",
                        fontSize: "10px",
                        fontWeight: "900",
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "2px solid #0f172a"
                    }}>
                        {unreadCount}
                    </span>
                )}
            </button>

            {/* Dropdown */}
            {showDropdown && (
                <div style={{
                    position: "absolute",
                    top: "50px",
                    right: "0",
                    width: "300px",
                    background: "#1e293b",
                    borderRadius: "16px",
                    border: "1px solid rgba(255,255,255,0.1)",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
                    zIndex: 1000,
                    overflow: "hidden"
                }}>
                    <div style={{ padding: "16px", borderBottom: "1px solid rgba(255,255,255,0.05)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span style={{ fontSize: "12px", fontWeight: "800", textTransform: "uppercase", letterSpacing: "1px" }}>Recent Activity</span>
                        <span style={{ fontSize: "10px", color: "rgba(255,255,255,0.4)" }}>Last 24h</span>
                    </div>

                    <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                        {alerts.length === 0 ? (
                            <div style={{ padding: "30px", textAlign: "center", color: "rgba(255,255,255,0.3)", fontSize: "11px", fontWeight: "700", textTransform: "uppercase" }}>
                                No recent activity
                            </div>
                        ) : (
                            alerts.map((alert, index) => (
                                <div key={index} style={{
                                    padding: "14px 16px",
                                    borderBottom: "1px solid rgba(255,255,255,0.03)",
                                    background: alert.type === 'deposit' ? "rgba(52, 211, 153, 0.05)" : "rgba(99, 102, 241, 0.05)",
                                    cursor: "pointer",
                                    transition: "all 0.2s"
                                }}
                                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.05)"}
                                onMouseLeave={e => e.currentTarget.style.background = alert.type === 'deposit' ? "rgba(52, 211, 153, 0.05)" : "rgba(99, 102, 241, 0.05)"}
                                >
                                    <div style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
                                        <span style={{ fontSize: "16px" }}>{alert.type === 'deposit' ? '💰' : '👤'}</span>
                                        <div>
                                            <div style={{ fontSize: "12px", fontWeight: "600", color: "#f8fafc", lineHeight: "1.4" }}>
                                                {alert.message}
                                            </div>
                                            <div style={{ fontSize: "10px", color: "rgba(255,255,255,0.4)", marginTop: "4px" }}>
                                                {new Date(alert.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                            </div>
                                        </div>
                                    </div>
                                    {alert.type === 'deposit' && (
                                        <Link to="/winrox11-super-admin/manage-deposits" style={{ display: "block", marginTop: "8px", fontSize: "9px", color: "#34d399", fontWeight: "800", textTransform: "uppercase", textDecoration: "none" }}>
                                            Go to Approval →
                                        </Link>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminAlerts;
